<template>
    <nav class="navbar navbar-expand bg-light navbar-light sticky-top px-4 py-0">
        <a href="index.html" class="navbar-brand d-flex d-lg-none me-4">
            <h2 class="text-primary mb-0"><i class="fa fa-hashtag"></i></h2>
        </a>
        <a href="#" class="sidebar-toggler flex-shrink-0" @click.prevent="layoutStore.toggleSidebar()">
            <i><font-awesome-icon icon="fa-solid fa-bars" /></i>
        </a>
        <!-- <form class="d-none d-md-flex ms-4"> -->
            <!-- <input class="form-control border-0" type="search" placeholder="Search"> -->
            
            <div class="d-none d-md-flex ms-4">
                <div class="nav-item dropdown">
                <!-- <a href="#" class="nav-link dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false"> -->
                    <input class="form-control border-0" v-model="query" @input="fetchResults" placeholder="Search..." />
                <!-- </a> -->
                    <div v-if="results.length > 0" class="nav-link dropdown-toggle" style="position: absolute;">
                        <div class="dropdown-menu dropdown-menu-end bg-light border-0 rounded-0 rounded-bottom m-0 show">
                            <template v-for="stock in results" :key="stock.stock_id">
                                <router-link target="_blank" name="stoke-view" :to="{ path: '/stock/view', query: { id: stock.code }}" class="dropdown-item">
                                    <h6 class="fw-normal mb-0">{{ stock.name }}</h6>
                                    <small>{{ stock.code }}</small>
                                </router-link>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
            
        <!-- </form> -->
        <div class="navbar-nav align-items-center ms-auto">

            <router-link to="/docs" class="nav-item nav-link d-flex align-items-center me-2 text-decoration-none" title="System Documentation">
                <i class="me-1"><font-awesome-icon icon="fa-solid fa-book-open" /></i>
                <span class="d-none d-lg-inline-flex">Docs</span>
            </router-link>

            <div class="nav-item dropdown">
                <a href="#" class="nav-link dropdown-toggle" data-bs-toggle="dropdown" ref="dropdownRef">
                    <i><font-awesome-icon icon="fa-solid fa-building-columns" /></i>
                    <span class="d-none d-lg-inline-flex">Platform</span>
                </a>
                <div class="dropdown-menu dropdown-menu-end bg-light border-0 rounded-0 rounded-bottom m-0">
                    <a href="#" class="dropdown-item">
                        <div class="d-flex align-items-center">
                            <div class="row">
                                <div class="ms-2" v-for="platform in platforms" :key="platform">
                                    <div class="d-flex align-items-center pt-2">
                                    <input class="form-check-input m-0" type="checkbox" :value="platform.platform_id" v-model="platformOptions">
                                        <div class="w-100 ms-3">
                                            <div class="d-flex w-100 align-items-center justify-content-between">
                                                <span>{{ platform.name }}</span>
                                                <button class="btn btn-sm"><font-awesome-icon icon="fa-solid fa-arrow-up-right-from-square" /></button>
                                            </div>
                                            <small>{{ platform.fund }}</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </a>
                    <hr class="dropdown-divider">
                </div>
            </div>

            <div class="nav-item dropdown">
                <a href="#" class="nav-link dropdown-toggle" data-bs-toggle="dropdown">
                    <i><font-awesome-icon icon="fa-solid fa-chart-line" /></i>
                    <span class="d-none d-lg-inline-flex">{{ selectedStock ? selectedStock.code : 'Stocks' }}</span>
                </a>
                <div class="dropdown-menu dropdown-menu-end bg-light border-0 rounded-0 rounded-bottom m-0" style="width: min(380px, calc(100vw - 2rem)); max-height: min(420px, 70vh); overflow-y: auto;">
                    <div class="px-3 py-2">
                        <input class="form-control form-control-sm" v-model="stockQuery" placeholder="Filter stocks..." />
                    </div>
                    <hr class="dropdown-divider">
                    <a href="#" class="dropdown-item" :class="{ active: !selectedStock }" @click.prevent="selectStock(null)">
                        <h6 class="fw-normal mb-0">All stocks</h6>
                        <small>Show the whole portfolio on the dashboard</small>
                    </a>
                    <hr class="dropdown-divider">
                    <template v-if="visiblePlatformStocks.length">
                        <template v-for="(stock, index) in visiblePlatformStocks" :key="stock.stock_id">
                            <a href="#" class="dropdown-item" :class="{ active: selectedStock && selectedStock.stock_id === stock.stock_id }" @click.prevent="selectStock(stock)">
                                <div class="d-flex align-items-center justify-content-between gap-2">
                                    <h6 class="fw-normal mb-0 text-truncate" style="min-width: 0;">{{ stock.name }}</h6>
                                    <span class="badge flex-shrink-0" :class="stock.profit_loss >= 0 ? 'bg-success' : 'bg-danger'">{{ $helper.formatPercentage(stock.profit_loss_per) }}</span>
                                </div>
                                <small>{{ stock.code }} &middot; Qty {{ stock.qty }} &middot; {{ $helper.formatPrice(stock.current_value) }}</small>
                            </a>
                            <hr class="dropdown-divider" v-if="index < visiblePlatformStocks.length - 1">
                        </template>
                        <template v-if="hiddenPlatformStockCount">
                            <hr class="dropdown-divider">
                            <span class="dropdown-item-text d-block text-center text-muted"><small>+{{ hiddenPlatformStockCount }} more &mdash; refine the filter</small></span>
                        </template>
                    </template>
                    <a v-else href="#" class="dropdown-item text-center text-muted" @click.prevent>{{ platformStocksEmptyLabel }}</a>
                    <hr class="dropdown-divider">
                    <router-link to="/stock/list" class="dropdown-item text-center">View all stocks</router-link>
                </div>
            </div>

            <div class="nav-item dropdown">
                <a href="#" class="nav-link dropdown-toggle" data-bs-toggle="dropdown">
                    <i><font-awesome-icon icon="fa-solid fa-envelope" /></i>
                    <span class="d-none d-lg-inline-flex">Order Logs</span>
                </a>
                <div class="dropdown-menu dropdown-menu-end bg-light border-0 rounded-0 rounded-bottom m-0" style="width: min(380px, calc(100vw - 2rem)); max-height: min(420px, 70vh); overflow-y: auto;">
                    <template v-if="orderLogs.length">
                        <template v-for="(entry, index) in orderLogs" :key="entry.order_log_id">
                            <a href="#" class="dropdown-item" @click.prevent>
                                <div class="d-flex align-items-center justify-content-between gap-2">
                                    <h6 class="fw-normal mb-0 text-truncate" style="min-width: 0;">{{ entry.title }}</h6>
                                    <span class="badge flex-shrink-0" :class="orderLogBadgeClass(entry.event_type)">{{ orderLogTypeLabel(entry.event_type) }}</span>
                                </div>
                                <small>{{ formatOrderLogTime(entry.event_time) }}</small>
                            </a>
                            <hr class="dropdown-divider" v-if="index < orderLogs.length - 1">
                        </template>
                    </template>
                    <a v-else href="#" class="dropdown-item text-center text-muted" @click.prevent>No order logs yet</a>
                    <hr class="dropdown-divider">
                    <router-link to="/order-log" class="dropdown-item text-center">View all order logs</router-link>
                </div>
            </div>
            <div class="nav-item dropdown">
                <a href="#" class="nav-link dropdown-toggle" data-bs-toggle="dropdown">
                    <i><font-awesome-icon icon="fa-solid fa-bell" /></i>
                    <span class="d-none d-lg-inline-flex">Notifications</span>
                    <span v-if="pendingNotificationCount" class="badge bg-danger notification-count-badge">{{ pendingNotificationCount }}</span>
                </a>
                <div class="dropdown-menu dropdown-menu-end bg-light border-0 rounded-0 rounded-bottom m-0" style="width: min(380px, calc(100vw - 2rem)); max-height: min(420px, 70vh); overflow-y: auto;">
                    <template v-if="notifications.length">
                        <template v-for="(entry, index) in notifications" :key="entry.notification_id">
                            <router-link :to="`/notifications/${entry.notification_id}`" class="dropdown-item">
                                <div class="d-flex align-items-center justify-content-between gap-2">
                                    <h6 class="fw-normal mb-0 text-truncate" style="min-width: 0;">{{ entry.title }}</h6>
                                    <span class="badge flex-shrink-0" :class="notificationStatusBadgeClass(entry.status)">{{ entry.status }}</span>
                                </div>
                                <small>{{ formatOrderLogTime(entry.created_at) }}</small>
                            </router-link>
                            <hr class="dropdown-divider" v-if="index < notifications.length - 1">
                        </template>
                    </template>
                    <a v-else href="#" class="dropdown-item text-center text-muted" @click.prevent>No notifications yet</a>
                </div>
            </div>
            <div class="nav-item dropdown">
                <a href="#" class="nav-link dropdown-toggle" data-bs-toggle="dropdown">
                    <img :src="imageSrc" alt="" class="rounded-circle" :style="imageStyle" />
                    <span class="d-none d-lg-inline-flex">John Doe</span>
                </a>
                <div class="dropdown-menu dropdown-menu-end bg-light border-0 rounded-0 rounded-bottom m-0">
                    <a href="#" class="dropdown-item">My Profile</a>
                    <a href="#" class="dropdown-item">Settings</a>
                    <a href="#" class="dropdown-item" @click="logout()">Log Out</a>
                </div>
            </div>
        </div>
    </nav>
</template>

<script>
import { onMounted, onBeforeUnmount, ref } from 'vue'
import { useAuthStore, useAlertStore, useLayoutStore, platformStore, stockStore } from '@/stores'
import gql from 'graphql-tag'
import { fetchWrapper } from '@/helpers/fetch-wrapper'
import { orderLogTypeLabel, orderLogTypeColor } from '@/utils/orderLogTypes'
import moment from 'moment'

// Vuetify-style color names (used by the /order-log page) translated to
// Bootstrap badge classes for this Bootstrap-based navbar -- keeps the
// label/color map itself framework-agnostic and shared between both.
const BOOTSTRAP_COLOR_MAP = {
  primary: 'primary',
  info: 'info',
  success: 'success',
  warning: 'warning',
  error: 'danger',
  secondary: 'secondary',
}

const PLATFORMS_OPTION_QUERY = gql`
    query getPlatformList {
        platforms {
            platform_id,
            name,
            username,
            color
        }
    }`;

// The navbar's Stocks dropdown is a quick-jump list, not a report -- it reuses
// the same platform-wise aggregate the /stock/list page is built on (so the
// Platform checkboxes above filter both identically), but asks for only the
// handful of fields the dropdown row actually renders.
const NAVBAR_STOCK_LIST_QUERY = gql`
    query NavbarStockList($platformIds: [ID]) {
        stockListPlatformWise(platform_ids: $platformIds, advanced_filters: ["only_portfolio_stocks"]) {
            stockData {
                stock_id
                name
                code
                qty
                current_value
                profit_loss
                profit_loss_per
            }
        }
    }`;

// A portfolio can hold hundreds of stocks; a dropdown that renders all of them
// scrolls forever, so cap what is drawn and let the filter box narrow it down.
const NAVBAR_STOCK_LIMIT = 50;

const SEARCH_QUERY = gql`
    query Search($query: String!) {
        search(query: $query) {
            stock_id,
            name,
            code
        }
    }
`;

export default {
  name: 'Navbar-page',
  data() {
    return {
      imageSrc: require('@/assets/img/user.jpg'),
      imageStyle: {
        width: '40px',
        height: '40px',
      },
      platformOptions: this.$helper.getSelectedPlatformOptions()
        ? this.$helper.getSelectedPlatformOptions()
        : ['0'],
      query: '',
      results: [],
      orderLogs: [],
      notifications: [],
      platformStocks: [],
      stockQuery: '',
    }
  },
  setup() {
    //const vm = getCurrentInstance().proxy;
    const authStore = useAuthStore()
    const alertStore$ = useAlertStore()
    const layoutStore = useLayoutStore()
    const platformStore$ = platformStore()
    const stockStore$ = stockStore()
    const dropdownRef = ref(null)

    const onDropdownShown = () => {
      // Call your logic here
    }

    const onDropdownHidden = () => {
        const el = dropdownRef.value;
        const checkedValues = Array.from(el.closest('.dropdown')?.querySelectorAll('input[type="checkbox"]:checked') || [])
        .map(input => input.value);
        platformStore$.setPlatform(checkedValues);
    }

    onMounted(() => {
      const el = dropdownRef.value
      if (el) {
        el.addEventListener('shown.bs.dropdown', onDropdownShown)
        el.addEventListener('hidden.bs.dropdown', onDropdownHidden)
      }
    })

    onBeforeUnmount(() => {
      const el = dropdownRef.value
      if (el) {
        el.removeEventListener('shown.bs.dropdown', onDropdownShown)
        el.removeEventListener('hidden.bs.dropdown', onDropdownHidden)
      }
    })

    return {
      authStore,
      alertStore$,
      layoutStore,
      platformStore$,
      stockStore$,
      dropdownRef, // expose to template
    }
  },
  mounted() {
    fetchWrapper.get('api/order-log/recent').then((res) => {
      this.orderLogs = res?.data?.rows || []
    }).catch((error) => {
      console.error('Failed to load recent order logs:', error)
    })
    fetchWrapper.get('api/notifications/recent').then((res) => {
      this.notifications = res?.data?.rows || []
    }).catch((error) => {
      console.error('Failed to load recent notifications:', error)
    })
  },
  computed: {
    pendingNotificationCount() {
      return this.notifications.filter((n) => n.status === 'pending').length
    },

    // Read the platform selection off the store rather than this.platformOptions
    // so the list refetches as soon as the Platform dropdown commits a change,
    // instead of staying on whatever was selected when the navbar mounted.
    selectedPlatformIds() {
      try {
        const parsed = JSON.parse(this.platformStore$.platform || '[]')
        return Array.isArray(parsed) ? parsed : []
      } catch (error) {
        return []
      }
    },

    matchedPlatformStocks() {
      const term = this.stockQuery.trim().toLowerCase()
      if (!term) return this.platformStocks
      return this.platformStocks.filter((stock) =>
        `${stock.name || ''} ${stock.code || ''}`.toLowerCase().includes(term)
      )
    },

    visiblePlatformStocks() {
      return this.matchedPlatformStocks.slice(0, NAVBAR_STOCK_LIMIT)
    },

    hiddenPlatformStockCount() {
      return this.matchedPlatformStocks.length - this.visiblePlatformStocks.length
    },

    platformStocksEmptyLabel() {
      if (this.stockQuery.trim()) return 'No stocks match that filter'
      return 'No stocks for the selected platforms'
    },

    selectedStock() {
      return this.stockStore$.selectedStock
    },
  },
  methods: {
    // Picking a stock narrows the dashboard to it rather than navigating away,
    // so it behaves like the Platform checkboxes above -- a second filter
    // dimension on the same page. null clears the filter.
    selectStock(stock) {
      this.stockStore$.setStock(stock)
    },

    logout: function () {
      this.authStore.logout()
    },

    orderLogTypeLabel,

    orderLogBadgeClass(eventType) {
      const bootstrapColor = BOOTSTRAP_COLOR_MAP[orderLogTypeColor(eventType)] || 'secondary'
      return `bg-${bootstrapColor}`
    },

    notificationStatusBadgeClass(status) {
      if (status === 'pending') return 'bg-danger'
      if (status === 'applied') return 'bg-success'
      return 'bg-secondary'
    },

    formatOrderLogTime(eventTime) {
      if (!eventTime) return ''
      const parsed = moment(eventTime)
      return parsed.isValid() ? parsed.fromNow() : ''
    },

    async fetchResults() {
      try {
        if (this.query.trim() !== '') {
          const { data } = await this.$apollo.query({
            query: SEARCH_QUERY,
            variables: { query: this.query.trim() },
          })
          this.results = data.search
        } else {
          this.results = []
        }
      } catch (error) {
        console.error('Error fetching search results:', error)
      }
    },
  },
  watch: {
    'platforms': function (newVal) {
      this.platformStore$.setPlatformList(newVal)

      // First-ever visit (dropdown never touched, so localStorage has no
      // 'platform' key yet) -- default every checkbox to checked instead of
      // leaving them all unchecked until the user opens the dropdown once.
      if (localStorage.getItem('platform') === null && Array.isArray(newVal) && newVal.length) {
        const allIds = newVal.map((platform) => platform.platform_id)
        this.platformOptions = allIds
        this.platformStore$.setPlatform(allIds)
      }
    },
  },
  apollo: {
    platforms: {
      query: PLATFORMS_OPTION_QUERY,
      error(error) {
        // logout() clears the Apollo store while this query may still be
        // in-flight, which rejects it with an internal "store reset"
        // error -- not a real failure, so skip alerting once the user
        // session that triggered it is already gone (auth's own
        // UNAUTHENTICATED handling in apollo-client.ts has this covered).
        if (!this.authStore.user) return
        this.alertStore$.error(error.message)
      },
    },
    platformStocks: {
      query: NAVBAR_STOCK_LIST_QUERY,
      variables() {
        return { platformIds: this.selectedPlatformIds }
      },
      update(data) {
        return data?.stockListPlatformWise?.stockData || []
      },
      error(error) {
        // Same store-reset-on-logout caveat as the platforms query above.
        if (!this.authStore.user) return
        this.alertStore$.error(error.message)
      },
    },
  },
}
</script>